module.exports = __webpack_public_path__ + "media/images/payments/unionpay-dark-79382cadc3ef798a1e4843ab25ad15ee.svg";